// SPDX-License-Identifier: LicenseRef-MMS-WIRE
// Copyright (c) 2016-2026 Metal Management Solutions (Pty) Ltd

import {Component, computed, inject, Inject, Renderer2, signal} from '@angular/core';
import {HeaderDataService} from "../../services/header_data.service";
import {AppScope} from "../../services/app_scope.service";
import {AccountService} from "../../services/account.service";
import { takeUntil, tap} from "rxjs/operators";
import {Subject} from "rxjs";
import {Menu} from "../../menu-bars/menu-item.model";
import Keycloak from "keycloak-js";
import {MatToolbar} from "@angular/material/toolbar";
import {COMMON_FORM_IMPORTS, COMMON_MAT_MENU_IMPORTS} from "../../shared/import-groups/Common";
import {CommonModule} from "@angular/common";
import {RouterLink} from "@angular/router";
import {MatIcon} from "@angular/material/icon";
import {AccountPickerComponent} from "../account-picker/account-picker.component";
import {ThemeService} from "../../services/theme.service";
import {LOGIN_LOGO_URL} from "../../shared/globals";

@Component({
    selector: 'main-header',
    templateUrl: './main-header.component.html',
    imports: [
        MatToolbar,
        COMMON_FORM_IMPORTS,
        CommonModule,
        RouterLink,
        MatIcon,
        COMMON_MAT_MENU_IMPORTS,
        AccountPickerComponent
    ],
    styleUrls: ['./main-header.component.less']
})
export class MainHeaderComponent {
  loginImgSrc = signal(LOGIN_LOGO_URL);
  rightLogoSrc = this.headerData.rightLogoUrl;
  right_menu: Menu = {};

  readonly username = computed(() => {
    const profile = this.userProfile();
    if (!profile) {
        return null;
    }
    return profile.firstName || profile.username;
  });

  private readonly keycloak = inject(Keycloak);
  private readonly userProfile = signal<Keycloak.KeycloakProfile | null>(null);
  private readonly onDestroy: Subject<void> = new Subject<void>();

  constructor(public headerData: HeaderDataService,
              public appScope: AppScope,
              private renderer: Renderer2,
              @Inject('Window') private window: Window,
              public accountService: AccountService) {
      this.loadProfile()
  }

  private loadProfile() {
    this.keycloak.loadUserProfile().then(profile => {
      this.userProfile.set(profile);
    });
  }

  ngOnInit(): void {
      this.appScope.authComplete$.subscribe((isAuth) => {
          if (isAuth) {
              this.appScope.currentUserValue.pipe(
                  tap(() => {
                      if (this.appScope.config_name_map.hasOwnProperty("theme")) {
                          let theme = this.appScope.config_name_map.theme.value.name;
                          this.renderer.addClass(document.body, theme);
                      }
                      this.right_menu = this.headerData.buildRightMenu();
                  }),
                  takeUntil(this.onDestroy)).subscribe();

              this.accountService.activeAccountChanged.pipe(takeUntil(this.onDestroy))
                  .subscribe(response => {
                      this.appScope.refreshConfigurationSettings(response.account_id);
                      this.right_menu = this.headerData.buildRightMenu();
                  });
          }
      });
  }

  ngOnDestroy(): void {
      this.onDestroy.next();
      this.onDestroy.unsubscribe();
  }
}
